import { render, staticRenderFns } from "./partGroupEdit.vue?vue&type=template&id=1c96e40e"
import script from "./partGroupEdit.vue?vue&type=script&lang=js"
export * from "./partGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports